<template>
	<div class="main_zhanlan">
		<div class="zhanlan1" :style="{ backgroundImage: `url(${ ExhibitDetail.topBgUrl })` }">
			<div class="left">
				<div class="item">
					<div class="text1"><span>{{ $t('newbanner1') }}</span></div>
					<div class="text2">{{ En ? 'September 23-27' : '9月23日-27日' }}</div>
					<div class="text3">{{ En ? '2025' : '2025年' }}</div>
				</div>
				<div class="item" v-if="En && !isPc">
					<div class="text1"><span>{{ $t('newbanner2') }}</span></div>
					<div class="text2">National Exhibition & <br />Convention Center</div>
					<div class="text3">Shanghai · China</div>
				</div>
				<div class="item" v-else>
					<div class="text1"><span>{{ $t('newbanner2') }}</span></div>
					<div class="text2">{{ En ? 'National Exhibition & Convention Center 7.1H、8.1H' : '国家会展中心7.1H、8.1H' }}</div>
					<div class="text3">{{ En ? 'Shanghai · China ' : '中国 · 上海' }}</div>
				</div>
			</div>
			<img class="right" :src="ExhibitDetail.logoUrl" />
			<div class="text" :class="En ? 'text-en' : ''">
				{{ ExhibitDetail['name' + En] }}
				<div class="big">{{ ExhibitDetail['name' + En] }}</div>
			</div>
		</div>
		<div class="zhanlan2" :style="{ 'background-color': ExhibitDetail.themeColor }">
			<ul>
				<li v-for="(v, i) in FunctionModule" :key="i" @click="openChlidren(v, i)" :class="`${ blackTabPages.includes(ExhibitDetail.uuid) ? 'black' : '' } ${ leftIndex == v.name ? 'active' : '' }`">
					<span class="text1" :style="{ color: ExhibitDetail.themeColor }">{{ v['name' + En] }}</span>
					<span class="text2">{{ v['name' + En] }}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "zhanlan_top",
    data() {
        return {
			ExhibitDetail: JSON.parse(window.localStorage.getItem('ExhibitDetail')),
			FunctionModule: JSON.parse(window.localStorage.getItem('FunctionModule')),
			blackTabPages: ['fb5e89622d4241d8b21ecf956aad8', 'fb5e89622d4241d8b2cbc1ecf956aad8', 'fb5e89622d4241d8b2cbcf956aad8'],
        };
    },
	computed: {
		...mapState({
			headIndex: state => state.headIndex,
			leftIndex: state => state.leftIndex,
		}),
	},
	watch: {
		'$store.state.ExhibitDetail': {
			handler(v) {
				this.ExhibitDetail = JSON.parse(window.localStorage.getItem('ExhibitDetail'))
			},
			deep: true,
			immediate: true
		},
		'$store.state.FunctionModule': {
			handler(v) {
				this.FunctionModule = JSON.parse(window.localStorage.getItem('FunctionModule'))
			},
			deep: true,
			immediate: true
		},
	},
	methods: {
		// 点击二级菜单
		openChlidren(c, i) {
			this.$jsAPI('track', 'ciif_gbzyExhibitionHome_menul', {
				contentName_var: c.name,
				exhibitionName_var: this.ExhibitDetail.name,
			})
			let type = c.type
			this.$store.commit('setLeftIndex', c.name)
			if (c.multipleFileSts == 0) {
				this.$store.commit('setLeftIndex', c.name)
				this.$store.commit('setPageName', c)
				this.openLink({ link: '/match_process?code=' + c.code + (this.ExhibitDetail.uuid?'&pageType=exhibitPage':'&pageType=homePage') + '&type=more' })
				return
			}
			if(type == 1 || type == 2) {
				this.$store.commit('setPageName', c)
				this.openLink({
					link: '/match_process?code=' + c.code + '&pageType=exhibitPage'
				}, i)
			} else if (type == 3) {
				window.open(c.outLink);
			} else if (type == 4) {
				window.open(c['fileUrl' + this.En] || c['fileUrl'] || c.outLink);
			} else {
				this.openLink(c, i)
			}
		},
		// 点击一级菜单
		openLink(v, i) {
			if(v.link) {
				// this.$store.commit('setHeadIndex', i)
				if(v.query) {
					this.$router.push({
						path: v.link,
						query: { ...v.query
						}
					})
				} else {
					this.$router.push({
						path: v.link
					})
				}
			}
		},
	}
}
</script>

<style lang="less" scoped="scoped">
@media screen and (min-width: 769px) {
	.main_zhanlan {
		overflow: hidden;
		width: 100%;
		background-size: 100%;
		background-color: #F8F8F9;
		position: relative;
		z-index: 1;
		.m {
			width: 1640px;
			margin: 0 auto;
			margin-top: 100px;
			.main_showlist {
				overflow: hidden;
				width: 100%;
				margin-top: .8rem;
				margin-bottom: .8rem;
				.slidebox {
					display: flex;
					width: 100%;
					align-items: center;
					margin-top: 60px;
					.sw {
						display: flex;
						align-items: center;
						width: 100%;
						a {
							display: block;
							width: 2.37rem;
							height: .8rem;
							margin-right: .2rem;
							background-repeat: no-repeat;
							background-size: contain;
							background-position: center center;
							// filter: grayscale(100%);
							transition: all .2s;
							border-radius: 24px;
							overflow: hidden;
							&:hover {
								filter: grayscale(0%);
							}
						}
					}
					marquee {
						display: flex;
						align-items: center;
					}
				}
				.swiper {
					width: 100%;
					overflow: hidden;
					.swiper-wrapper {
						-webkit-transition-timing-function: linear !important;
						-moz-transition-timing-function: linear !important;
						-ms-transition-timing-function: linear !important;
						-o-transition-timing-function: linear !important;
						transition-timing-function: linear !important;
					}
					.swiper-slide {
						width: auto;
						margin-right: .2rem;
						img {
							height: .8rem;
							width: auto;
							// filter: grayscale(100%);
							transition: all .2s;
							&:hover {
								filter: grayscale(0%);
							}
						}
					}
				}
				ul {
					overflow: hidden;
					white-space: nowrap;
					overflow-x: scroll;
					&::-webkit-scrollbar {
						display: none;
					}
					li {
						overflow: hidden;
						margin: 0 .1rem;
						margin-top: .32rem;
						display: inline-block;
						img {
							display: block;
							width: auto;
							height: 0.8rem;
						}
					}
				}
			}
			.main_newss {
				.more {
					width: 1.28rem;
					height: .36rem;
					border-radius: .5rem;
					background: #005CA2;
					margin-right: .68rem;
					transition: all .1s;
					float: right;
					&:hover {
						opacity: 0.8;
					}
					a {
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: .2rem;
						color: #fff;
						line-height: 1;
					}
				}
				.box {
					width: 100%;
					position: relative;
					height: 476px;
					margin-top: 48px;
					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../assets/images/prev3.png);
							&:hover {
								background-image: url(../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../assets/images/next3.png);
							&:hover {
								background-image: url(../assets/images/next.png);
							}
						}
					}
					.swiper1-container {
						width: 100%;
						height: 100%;
						overflow: hidden;
					}
					.swiper {
						width: 100%;
						height: 100%;
						overflow: hidden;
						.swiper-slide {
							position: relative;
							cursor: pointer;
							width: 532px;
							height: 476px;
							background: #FFFFFF;
							border-radius: 24px;

							.label {
								padding: 36px 28px;

								div {
									display: flex;
									align-items: center;
									img {
										width: 22px;
										height: auto;
										margin-right: 6px;
									}
									em {
										font-family: Inter, syn;
										font-weight: 400;
										font-size: 20px;
										color: #5D5E5F;
										line-height: 20px;
										text-align: left;
										font-style: normal;
									}

									.space {
										margin-right: 40px;
									}
								}
								p {
									font-family: "syb";
									
									big {
										font-family: Inter, syn;
										font-weight: 600;
										font-size: 28px;
										color: #000000;
										line-height: 40px;
										height: 120px;
										text-align: left;
										font-style: normal;
										display: -webkit-box;
										-webkit-box-orient: vertical;
										-webkit-line-clamp: 3;
										overflow: hidden;
									}
								}
								.topBlurb {
									font-family: Inter, syn;
									font-weight: 400;
									font-size: 20px;
									color: #666666;
									line-height: 32px;
									text-align: left;
									font-style: normal;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden;
									/*max-height: 1.25rem;*/
									overflow: hidden;
								}

								.right-icon {
									margin: 60px 0;
									width: 42px;
									height: auto;
								}
							}

							&:hover {
								background-color: #FCD00A;

								.label {

									.topBlurb {
										color: #000000;
									}
								}
							}
						}
					}
				}
			}
			.slide_pic {
				width: 100%;
				border-radius: .28rem;
				position: relative;
				overflow: hidden;
				margin-bottom: 120px;
				.btn {
					width: .4rem;
					height: .4rem;
					background-size: 100% 100%;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					z-index: 999;
					cursor: pointer;
					&.prev {
						left: .16rem;
						background-image: url(../assets/images/prev1.png);
						&:hover {
							background-image: url(../assets/images/prev.png);
						}
					}
					&.next {
						right: .16rem;
						background-image: url(../assets/images/next1.png);
						&:hover {
							background-image: url(../assets/images/next.png);
						}
					}
				}
				.pic {
					width: 100%;
					cursor: pointer;
				}
			}
			.main_moment {
				overflow: hidden;
				width: 100%;
				position: relative;
				padding-left: 1036px;
				min-height: 580px;
				margin-bottom: 100px;
				.video {
					width: 916px;
					height: 579px;
					border-radius: 24px;
					overflow: hidden;
					position: absolute;
					left: 0;
					top: 0;
					padding-top: 18px;
					border: 1px solid rgba(11, 36, 63, 0.2);
					background-color: #F3F4F5;

					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../assets/images/prev1.png);
							&:hover {
								background-image: url(../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../assets/images/next1.png);
							&:hover {
								background-image: url(../assets/images/next.png);
							}
						}
					}
					img {
						width: 1.6rem;
						position: absolute;
						cursor: pointer;
						z-index: 999;
						left: 50%;
						transform: translate(-50%, -50%);
						top: 50%;
					}
					video {
						width: 880px;
						height: 495px;
						border-radius: .28rem;
						object-fit: cover;
						margin: 0 auto;
						display: block;
					}

					.swiper-pagination {
						display: flex;
						justify-content: center;
						width: 100%;
						margin-top: 24px;

						/deep/ .swiper-pagination-bullet {
							margin: 0 8px;
							width: 10px;
							height: 10px;
							background-color: #C4CAD1;
							opacity: 1;

							&.swiper-pagination-bullet-active {
								background-color: #F4511E;
							}
						}
					}
				}
						
				.slide-img {
					width: 100% !important;
					height: 7.2rem !important;
					position: static !important;
					transform: translate(0, 0) !important;
				}

				.right {
					min-height: 600px;
					padding-top: 60px;
					position: relative;
					z-index: 1;

					.right1 {
						display: flex;
						align-items: center;
						font-family: MiSans, MiSans;
						font-weight: 600;
						font-size: 16px;
						color: #999999;
						line-height: 26px;
						text-align: left;
						font-style: normal;

						.icon {
							margin-left: 6px;
							width: 32px;
							height: auto;
						}
					}

					.right2 {
						font-family: Inter, syn;
						font-weight: 600;
						font-size: 48px;
						color: #0B243F;
						line-height: 52px;
						text-align: left;
						font-style: normal;
						margin: 60px 0 24px;
					}

					.right3 {
						font-family: Inter, syn;
						font-weight: 400;
						font-size: 20px;
						color: #666666;
						line-height: 32px;
						text-align: left;
						font-style: normal;
						margin-bottom: 48px;
					}

					.btns {
						display: flex;

						.btn {
							height: 56px;
							border: 1px solid rgba(11, 36, 63, 0.6);
							border-radius: 12px;
							font-family: MiSans, MiSans;
							font-weight: 500;
							font-size: 16px;
							color: #0B243F;
							line-height: 16px;
							text-align: left;
							font-style: normal;
							padding: 0 28px 0 20px;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-right: 16px;
							cursor: pointer;

							img {
								width: 24px;
								height: auto;
								margin-left: 12px;
								display: none;

								&.img1 {
									display: block;
								}

								&.img2 {
									display: none;
								}
							}

							&:hover {
								background-color: #F4501C;
								border-color: #F4501C;
								color: #fff;

								img {

									&.img1 {
										display: none;
									}

									&.img2 {
										display: block;
									}
								}
							}
						}
					}
				}
			}
		}

		.zhanlan1 {
			height: 520px;
			background-size: cover;
			background-color: rgba(0, 0, 0, 0.5);
			position: relative;

			.left {
				position: absolute;
				left: 140px;
				top: 380px;
				display: flex;

				.item {
					margin-right: 100px;

					.text1 {
						
						span {
							font-family: MiSans, MiSans;
							font-weight: 400;
							font-size: 14px;
							color: #F4501C;
							line-height: 14px;
							text-align: left;
							font-style: normal;
							text-transform: uppercase;
							position: relative;
							display: inline-block;

							&::before {
								content: "";
								position: absolute;
								left: 0;
								right: 0;
								top: -5px;
								height: 1px;
								background: #F4501C;
								opacity: 0.8;
							}
						}
					}

					.text2 {
						margin: 8px 0;
						font-family: MiSans, MiSans;
						font-weight: 500;
						font-size: 24px;
						color: #fff;
						line-height: 24px;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: MiSans, MiSans;
						font-weight: 400;
						font-size: 18px;
						color: #fff;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}
				}
			}

			.right {
				position: absolute;
				right: 140px;
				top: 180px;
				width: 240px;
				height: 240px;
				border-radius: 24px;
			}

			.text {
				position: absolute;
				left: 140px;
				top: 150px;
				font-family: syb;
				font-weight: 600;
				font-size: 72px;
				color: #FFFFFF;
				line-height: 80px;
				text-align: left;
				font-style: normal;
				text-transform: uppercase;
				position: relative;
				width: 1240px;
				
				.big {
					position: absolute;
					width: 100%;
					left: -140px;
					top: 14px;
					transform: scale(1.667);
					transform-origin: left top;
					color: rgba(255, 255, 255, 0.04);
					font-weight: bold;
				}

				&.text-en {
					font-family: Inter SemiBold;
				}
			}
		}

		.zhanlan2 {
			width: 100%;
			
			ul {
				width: 1640px;
				height: 100%;
				margin: 0 auto;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				padding: 9px 0;

				li {
					height: 44px;
					border-radius: 24px;
					border: 1px solid rgba(255, 255, 255, 0.4);
					font-family: Inter, syn;
					font-weight: 500;
					font-size: 22px;
					color: #fff;
					line-height: 22px;
					text-align: left;
					font-style: normal;
					padding: 0 22px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					margin: 10px 0;
					margin-right: 8px;

					.text1 {
						display: none;
					}

					.text2 {
						display: inline;
					}

					&:hover, &.active {
						background-color: #fff;
						color: #fff;

						.text1 {
							display: inline;
						}

						.text2 {
							display: none;
						}
					}

					&.black {
						border-color: rgba(0, 0, 0, 0.2);
						color: #000;

						&:hover, &.active {
							background-color: #000;
							color: #fff;

							.text1 {
								display: none;
							}

							.text2 {
								display: inline;
							}
						}
					}
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.main_zhanlan {
		overflow: hidden;
		width: 100%;
		background-size: 100%;
		background-color: #F8F8F9;
		position: relative;
		z-index: 1;
		.m {
			width: 1640px;
			margin: 0 auto;
			margin-top: 100px;
			.main_showlist {
				overflow: hidden;
				width: 100%;
				margin-top: .8rem;
				margin-bottom: .8rem;
				.slidebox {
					display: flex;
					width: 100%;
					align-items: center;
					margin-top: 60px;
					.sw {
						display: flex;
						align-items: center;
						width: 100%;
						a {
							display: block;
							width: 2.37rem;
							height: .8rem;
							margin-right: .2rem;
							background-repeat: no-repeat;
							background-size: contain;
							background-position: center center;
							// filter: grayscale(100%);
							transition: all .2s;
							border-radius: 24px;
							overflow: hidden;
							&:hover {
								filter: grayscale(0%);
							}
						}
					}
					marquee {
						display: flex;
						align-items: center;
					}
				}
				.swiper {
					width: 100%;
					overflow: hidden;
					.swiper-wrapper {
						-webkit-transition-timing-function: linear !important;
						-moz-transition-timing-function: linear !important;
						-ms-transition-timing-function: linear !important;
						-o-transition-timing-function: linear !important;
						transition-timing-function: linear !important;
					}
					.swiper-slide {
						width: auto;
						margin-right: .2rem;
						img {
							height: .8rem;
							width: auto;
							// filter: grayscale(100%);
							transition: all .2s;
							&:hover {
								filter: grayscale(0%);
							}
						}
					}
				}
				ul {
					overflow: hidden;
					white-space: nowrap;
					overflow-x: scroll;
					&::-webkit-scrollbar {
						display: none;
					}
					li {
						overflow: hidden;
						margin: 0 .1rem;
						margin-top: .32rem;
						display: inline-block;
						img {
							display: block;
							width: auto;
							height: 0.8rem;
						}
					}
				}
			}
			.main_newss {
				.more {
					width: 1.28rem;
					height: .36rem;
					border-radius: .5rem;
					background: #005CA2;
					margin-right: .68rem;
					transition: all .1s;
					float: right;
					&:hover {
						opacity: 0.8;
					}
					a {
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: .2rem;
						color: #fff;
						line-height: 1;
					}
				}
				.box {
					width: 100%;
					position: relative;
					height: 476px;
					margin-top: 48px;
					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../assets/images/prev3.png);
							&:hover {
								background-image: url(../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../assets/images/next3.png);
							&:hover {
								background-image: url(../assets/images/next.png);
							}
						}
					}
					.swiper1-container {
						width: 100%;
						height: 100%;
						overflow: hidden;
					}
					.swiper {
						width: 100%;
						height: 100%;
						overflow: hidden;
						.swiper-slide {
							position: relative;
							cursor: pointer;
							width: 532px;
							height: 476px;
							background: #FFFFFF;
							border-radius: 24px;

							.label {
								padding: 36px 28px;

								div {
									display: flex;
									align-items: center;
									img {
										width: 22px;
										height: auto;
										margin-right: 6px;
									}
									em {
										font-family: Inter, syn;
										font-weight: 400;
										font-size: 20px;
										color: #5D5E5F;
										line-height: 20px;
										text-align: left;
										font-style: normal;
									}

									.space {
										margin-right: 40px;
									}
								}
								p {
									font-family: "syb";
									
									big {
										font-family: Inter, syn;
										font-weight: 600;
										font-size: 28px;
										color: #000000;
										line-height: 40px;
										height: 120px;
										text-align: left;
										font-style: normal;
										display: -webkit-box;
										-webkit-box-orient: vertical;
										-webkit-line-clamp: 3;
										overflow: hidden;
									}
								}
								.topBlurb {
									font-family: Inter, syn;
									font-weight: 400;
									font-size: 20px;
									color: #666666;
									line-height: 32px;
									text-align: left;
									font-style: normal;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden;
									/*max-height: 1.25rem;*/
									overflow: hidden;
								}

								.right-icon {
									margin: 60px 0;
									width: 42px;
									height: auto;
								}
							}

							&:hover {
								background-color: #FCD00A;

								.label {

									.topBlurb {
										color: #000000;
									}
								}
							}
						}
					}
				}
			}
			.slide_pic {
				width: 100%;
				border-radius: .28rem;
				position: relative;
				overflow: hidden;
				margin-bottom: 120px;
				.btn {
					width: .4rem;
					height: .4rem;
					background-size: 100% 100%;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					z-index: 999;
					cursor: pointer;
					&.prev {
						left: .16rem;
						background-image: url(../assets/images/prev1.png);
						&:hover {
							background-image: url(../assets/images/prev.png);
						}
					}
					&.next {
						right: .16rem;
						background-image: url(../assets/images/next1.png);
						&:hover {
							background-image: url(../assets/images/next.png);
						}
					}
				}
				.pic {
					width: 100%;
					cursor: pointer;
				}
			}
			.main_moment {
				overflow: hidden;
				width: 100%;
				position: relative;
				padding-left: 1036px;
				min-height: 580px;
				margin-bottom: 100px;
				.video {
					width: 916px;
					height: 579px;
					border-radius: 24px;
					overflow: hidden;
					position: absolute;
					left: 0;
					top: 0;
					padding-top: 18px;
					border: 1px solid rgba(11, 36, 63, 0.2);
					background-color: #F3F4F5;

					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../assets/images/prev1.png);
							&:hover {
								background-image: url(../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../assets/images/next1.png);
							&:hover {
								background-image: url(../assets/images/next.png);
							}
						}
					}
					img {
						width: 1.6rem;
						position: absolute;
						cursor: pointer;
						z-index: 999;
						left: 50%;
						transform: translate(-50%, -50%);
						top: 50%;
					}
					video {
						width: 880px;
						height: 495px;
						border-radius: .28rem;
						object-fit: cover;
						margin: 0 auto;
						display: block;
					}

					.swiper-pagination {
						display: flex;
						justify-content: center;
						width: 100%;
						margin-top: 24px;

						/deep/ .swiper-pagination-bullet {
							margin: 0 8px;
							width: 10px;
							height: 10px;
							background-color: #C4CAD1;
							opacity: 1;

							&.swiper-pagination-bullet-active {
								background-color: #F4511E;
							}
						}
					}
				}
						
				.slide-img {
					width: 100% !important;
					height: 7.2rem !important;
					position: static !important;
					transform: translate(0, 0) !important;
				}

				.right {
					min-height: 600px;
					padding-top: 60px;
					position: relative;
					z-index: 1;

					.right1 {
						display: flex;
						align-items: center;
						font-family: MiSans, MiSans;
						font-weight: 600;
						font-size: 16px;
						color: #999999;
						line-height: 26px;
						text-align: left;
						font-style: normal;

						.icon {
							margin-left: 6px;
							width: 32px;
							height: auto;
						}
					}

					.right2 {
						font-family: Inter, syn;
						font-weight: 600;
						font-size: 48px;
						color: #0B243F;
						line-height: 52px;
						text-align: left;
						font-style: normal;
						margin: 60px 0 24px;
					}

					.right3 {
						font-family: Inter, syn;
						font-weight: 400;
						font-size: 20px;
						color: #666666;
						line-height: 32px;
						text-align: left;
						font-style: normal;
						margin-bottom: 48px;
					}

					.btns {
						display: flex;

						.btn {
							height: 56px;
							border: 1px solid rgba(11, 36, 63, 0.6);
							border-radius: 12px;
							font-family: MiSans, MiSans;
							font-weight: 500;
							font-size: 16px;
							color: #0B243F;
							line-height: 16px;
							text-align: left;
							font-style: normal;
							padding: 0 28px 0 20px;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-right: 16px;
							cursor: pointer;

							img {
								width: 24px;
								height: auto;
								margin-left: 12px;
								display: none;

								&.img1 {
									display: block;
								}

								&.img2 {
									display: none;
								}
							}

							&:hover {
								background-color: #F4501C;
								border-color: #F4501C;
								color: #fff;

								img {

									&.img1 {
										display: none;
									}

									&.img2 {
										display: block;
									}
								}
							}
						}
					}
				}
			}
		}

		.zhanlan1 {
			height: 6.8rem;
			background-size: cover;
			background-color: rgba(0, 0, 0, 0.5);
			position: relative;

			.left {
				position: absolute;
				left: .36rem;
				bottom: .58rem;

				.item {
					margin-top: .48rem;

					.text1 {
						
						span {
							font-family: MiSans, MiSans;
							font-weight: 400;
							font-size: .18rem;
							color: #F4501C;
							line-height: 1;
							text-align: left;
							font-style: normal;
							text-transform: uppercase;
							position: relative;
							display: inline-block;

							&::before {
								content: "";
								position: absolute;
								left: 0;
								right: 0;
								top: -4px;
								height: 1px;
								background: #F4501C;
								opacity: 0.8;
							}
						}
					}

					.text2 {
						margin: .08rem 0;
						font-family: MiSans, MiSans;
						font-weight: 500;
						font-size: .28rem;
						color: #fff;
						line-height: .28rem;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: MiSans, MiSans;
						font-weight: 400;
						font-size: .22rem;
						color: #fff;
						line-height: .22rem;
						text-align: left;
						font-style: normal;
					}
				}
			}

			.right {
				position: absolute;
				right: .36rem;
				top: 3.92rem;
				width: 2.4rem;
				height: 2.4rem;
				border-radius: .24rem;
			}

			.text {
				position: absolute;
				left: .36rem;
				top: 1.6rem;
				font-family: syb;
				font-size: .6rem;
				color: #FFFFFF;
				line-height: .6rem;
				text-align: left;
				font-style: normal;
				text-transform: uppercase;
				position: relative;
				width: 7.14rem;
				
				.big {
					position: absolute;
					width: 100%;
					left: -0.36rem;
					top: 0.1rem;
					transform: scale(1.1);
					transform-origin: left top;
					color: rgba(255, 255, 255, 0.04);
					font-weight: bold;
				}

				&.text-en {
					font-family: Inter SemiBold;
				}
			}
		}

		.zhanlan2 {
			width: 100%;
			padding-left: .36rem;
			
			ul {
				height: 100%;
				margin: 0 auto;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				padding: .28rem 0 1px;

				li {
					height: .56rem;
					border-radius: .28rem;
					border: 1px solid rgba(255, 255, 255, 0.4);
					font-family: Inter, syn;
					font-weight: 500;
					font-size: .26rem;
					color: #fff;
					line-height: .26rem;
					text-align: left;
					font-style: normal;
					padding: 0 .24rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					margin-right: .12rem;
					margin-bottom: .28rem;

					.text1 {
						display: none;
					}

					.text2 {
						display: inline;
					}

					&:hover, &.active {
						background-color: #fff;
						color: #fff;

						.text1 {
							display: inline;
						}

						.text2 {
							display: none;
						}
					}

					&.black {
						border-color: rgba(0, 0, 0, 0.2);
						color: #000;

						&:hover, &.active {
							background-color: #000;
							color: #fff;

							.text1 {
								display: none;
							}

							.text2 {
								display: inline;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/zhanlan_top.vue